import React, { useEffect, useState } from 'react';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Collapse from '@mui/material/Collapse';
import { getWelcomeBanner } from '../../services/settingsService';

const LOCALSTORAGE_KEY = 'welcomeBannerDismissed';

function hashMessage(message: string): string {
  // Simple hash for message tracking
  let hash = 0, i, chr;
  if (message.length === 0) return hash.toString();
  for (i = 0; i < message.length; i++) {
    chr = message.charCodeAt(i);
    hash = ((hash << 5) - hash) + chr;
    hash |= 0;
  }
  return hash.toString();
}

const WelcomeBanner: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [bannerId, setBannerId] = useState('');

  useEffect(() => {
    getWelcomeBanner()
      .then(data => {
        if (data && data.WelcomeBanner) {
          const msg = data.WelcomeBanner;
          const id = hashMessage(msg);
          setMessage(msg);
          setBannerId(id);
          const dismissed = localStorage.getItem(LOCALSTORAGE_KEY);
          if (dismissed !== id) {
            setOpen(true);
          }
        }
      })
      .catch(() => {});
  }, []);

  const handleClose = () => {
    setOpen(false);
    if (bannerId) {
      localStorage.setItem(LOCALSTORAGE_KEY, bannerId);
    }
  };

  return (
    <Collapse in={open}>
      {message && (
        <Alert
          severity="info"
          variant="filled"
          sx={{ borderRadius: 0, justifyContent: 'center', alignItems: 'center' }}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleClose}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {message}
        </Alert>
      )}
    </Collapse>
  );
};

export default WelcomeBanner;
